import FactoryComponents from '../../../../../../factory/components/FactoryComponents.js';
import moment from "moment";
import {getStaffList, getWorkerByApplica} from "@/api/processManager";
import ProcessWorkPermitSelectPopup from '../../workPermit/ProcessWorkPermitSelectPopup.vue';

const root = {}
export default root
root.name = 'processWorkPermitLD';
root.props = {
	initUserData: Object,
	areaData: Object,
	operaDataCache: Object,
	workerSelect: Array,
	applicantSelect: Array,
	workPermitType: Object,
	departmentSelect: Array
}
root.components = {
	ProcessWorkPermitSelectPopup
}
root.data = {
	workPermitLDData: {
		isShowProcessWorkPermitSelectPopup: false,
		preWorkInfo: [],
		headerDataCache: {
			//作业证编号
			no: '',
			//作业证名称
			name: new Date().getTime(),
			//计划开始时间
			planStartTime: '',
			//计划结束时间
			planEndTime: '',
			//区域id
			locationId: 0,

			departmentId:0,
			//作业地点
			place: '',
			protectionProduct: '',
			acceptanceEmpId: Number(localStorage.getItem("empId")), // 完工验收人id
			acceptanceOpinion: '',//完收验工意见
			reviewEmpId: Number(localStorage.getItem("empId")), // 复核人id
			reviewOpinion: '',	//复核人意见
			applyUserId: Number(localStorage.getItem("empId")), // 申请人id
			applyTime: moment().format('YYYY-MM-DD HH:mm:ss'),//申请作业时间
			jobExecutorEmpId: '',//作业人
			contractorId: null, // 申请单位id
			// TODO 新增
			certificateTypeId: 3, // 类型
		},

		//操作的缓存数据
		operaDataCache: {
			//申请单位
			au: '',
			//负责人
			charger: '',
			//电源接入点
			pap: '',
			//作业证电压
			wv: '',
			//设备功率
			eep: '',
			//电工证号
			ecNo: '',
			//危险辨识
			hi: [],
			//安全措施
			sms: [],


			wtcNo: '', //作业人电工证
			//属作业单位负责人
			wuoUser: 0,
			//作业单位意见
			wuo: '',
			//配送点单位负责人
			duoUser: 0,

			companyCharger: 0,//作业单位负责人
			companyChargerComment: '',//作业单位负责人意见
			distributeCharger: 0,//配送点单位负责人
			distributeChargerComment: '',//配送点单位负责人意见
			approveCharger: 0,//审批部门负责人
			approveChargerComment: '',//审批部门负责人意见

			name: null, // 作业内容
			playFire: [
				{ fm: '', stw: '', wtcNo: '' }
			], // 作业人员
			analysis: [//可燃气体分析
				{
					time: moment().format('YYYY-MM-DD HH:mm:ss'), // 分析时间
					position: '', // 分析名称
					result: '', // 分析数据
					assayerId: Number(localStorage.getItem("empId")), // 分析人
				}
			],
			//安全交底人
			aqjdrId: 0,
			//接受交底人
			jsjdrId: 0,
			//作业内容
			content: '',
		},
	}
}

root.methods = {
	//格式化选择的涉及的其他特殊作业及编号
	formatPreWorkInfo: function () {
		let data = []
		for (var i = 0; i < this.workPermitLDData.preWorkInfo.length; i++) {
			let element = this.workPermitLDData.preWorkInfo[i]
			data.push(`${element.name}(${element.no})`)
		}

		data = data.join(',')
		return data
	},
	//获取选择的涉及的其他特殊作业及编号
	getWorkPermitData: function (e) {
		this.workPermitLDData.preWorkInfo = []
		e.forEach(element => {
			element.selectData.forEach(item => {
				this.workPermitLDData.preWorkInfo.push({ 'no': item.no, 'name': item.name })
			});
		});
		this.$store.commit('setPreWorkInfo', this.workPermitLDData.preWorkInfo)
		this.workPermitLDData.isShowProcessWorkPermitSelectPopup = false

	},
	toOpenWorkCodePopup: function () {
		this.workPermitLDData.isShowProcessWorkPermitSelectPopup = true
	},
	syncPlayFireFromHeader: function () {
		const headerData = this.workPermitLDData.headerDataCache;
		const operaData = this.workPermitLDData.operaDataCache;
		if (!Array.isArray(operaData.playFire) || !operaData.playFire.length) {
			operaData.playFire = [{ fm: '', stw: '', wtcNo: '' }];
		}
		if (headerData.jobExecutorEmpId) {
			operaData.playFire[0].fm = headerData.jobExecutorEmpId;
		}
		if (operaData.wtcNo) {
			operaData.playFire[0].wtcNo = operaData.wtcNo;
		}
	},
	returnCacheData: function () {
		this.syncPlayFireFromHeader();
		return { ...this.workPermitLDData.headerDataCache, electricityPropsDto: this.workPermitLDData.operaDataCache };
	},

	// 解析业务字段，编辑时按新增页默认字段补齐
	fillPermitData: function (data, preserveWhenMissing) {
		data = data || {};
		this.workPermitLDData.headerDataCache = { ...this.workPermitLDData.headerDataCache, ...data };
		let businessData = {};
		if (data.businessJson) {
			if (typeof data.businessJson === 'object') {
				businessData = data.businessJson;
			} else {
				try {
					businessData = JSON.parse(data.businessJson);
				} catch (e) {
					businessData = {};
				}
			}
		}
		this.workPermitLDData.operaDataCache = { ...this.workPermitLDData.operaDataCache, ...businessData };
		if (!Array.isArray(this.workPermitLDData.operaDataCache.playFire) || !this.workPermitLDData.operaDataCache.playFire.length) {
			this.workPermitLDData.operaDataCache.playFire = [{ fm: '', stw: '', wtcNo: '' }];
		}
		if (!this.workPermitLDData.operaDataCache.playFire[0].fm && this.workPermitLDData.headerDataCache.jobExecutorEmpId) {
			this.workPermitLDData.operaDataCache.playFire[0].fm = this.workPermitLDData.headerDataCache.jobExecutorEmpId;
		}
		if (!this.workPermitLDData.operaDataCache.playFire[0].wtcNo && this.workPermitLDData.operaDataCache.wtcNo) {
			this.workPermitLDData.operaDataCache.playFire[0].wtcNo = this.workPermitLDData.operaDataCache.wtcNo;
		}
		if (!this.workPermitLDData.operaDataCache.wtcNo && this.workPermitLDData.operaDataCache.playFire[0].wtcNo) {
			this.workPermitLDData.operaDataCache.wtcNo = this.workPermitLDData.operaDataCache.playFire[0].wtcNo;
		}
		if (!this.workPermitLDData.operaDataCache.wtcNo && data.wtcNo) {
			this.workPermitLDData.operaDataCache.wtcNo = data.wtcNo;
			this.workPermitLDData.operaDataCache.playFire[0].wtcNo = data.wtcNo;
		}
		if (!Array.isArray(this.workPermitLDData.operaDataCache.analysis) || !this.workPermitLDData.operaDataCache.analysis.length) {
			this.workPermitLDData.operaDataCache.analysis = [{
				time: moment().format('YYYY-MM-DD HH:mm:ss'),
				position: '',
				result: '',
				assayerId: Number(localStorage.getItem("empId")),
			}];
		}
		if (!Array.isArray(this.workPermitLDData.operaDataCache.sms) || !this.workPermitLDData.operaDataCache.sms.length) {
			this.workPermitLDData.operaDataCache.sms = [];
			this.getPermitTypeData();
		}
		this.backfillPreWorkInfo(data, preserveWhenMissing);
	},
	// 回填涉及的其他特殊作业及编号
	backfillPreWorkInfo: function (data, preserveWhenMissing) {
		const hasPreWorkInfo = data && Object.prototype.hasOwnProperty.call(data, 'preWorkInfo');
		if (!hasPreWorkInfo && preserveWhenMissing) {
			this.$store.commit('setPreWorkInfo', this.workPermitLDData.preWorkInfo);
			return;
		}
		let preWorkInfo = hasPreWorkInfo ? data.preWorkInfo : [];
		if (typeof preWorkInfo === 'string') {
			try {
				preWorkInfo = preWorkInfo ? JSON.parse(preWorkInfo) : [];
			} catch (e) {
				preWorkInfo = [];
			}
		}
		if (!Array.isArray(preWorkInfo)) {
			preWorkInfo = [];
		}
		this.workPermitLDData.preWorkInfo = preWorkInfo;
		this.$store.commit('setPreWorkInfo', preWorkInfo);
	},

	//数据回填
	dataBackfill: function (data) {
		this.fillPermitData(data, true);
	},
	//Todo	获取临时用电安全-措施确认sms
	getPermitTypeData: function () {
		const self = this;
		this.componentsMoudel.startPost('/safetyMeasures/list_all', { permitType: 0 }, true).then(res => {
			self.workPermitLDData.operaDataCache.sms = res.body.data;
		});
	},

	// 2023-3-1新增
	// 添加作业人员
	addPlayFirer: function () {
		this.workPermitLDData.operaDataCache.playFire.push(
			{ fm: '', stw: '', wtcNo: '' }
		)
	},
	// 删除作业人员
	deletePlayFirer: function (index) {
		this.workPermitLDData.operaDataCache.playFire.splice(index, 1)
	},
	// 根据施工单位和作业类型查询动火人
	/*constructionUnit: function (value) {
		let obj = this.applicantSelect.find(v => {
			return value === v.id
		})
		this.workPermitLDData.operaDataCache.cuName = obj.contrName
		getStaffList().then(res => {
			//getWorkerByApplica({ contractorId: value, certificateTypeId: this.operaDataCache.certificateTypeId }).then(res => {
			this.workPermitLDData.operaDataCache.playFire = [{ fm: '', stw: '', wtcNo: '' }]
			this.workerSelect = res.body.data
		})
	},
	*/

	// 添加分析
	addHotAnalysis: function () {
		this.workPermitLDData.operaDataCache.analysis.push(
			{
				time: moment().format('YYYY-MM-DD HH:mm:ss'), // 分析时间
				position: '', // 分析名称
				result: '', // 分析数据
				assayerId: Number(localStorage.getItem("empId")), // 分析人
			}
		)
	},
	// 删除分析
	deleteHotAnalysis: function (index) {
		this.workPermitLDData.operaDataCache.analysis.splice(index, 1)
	},
	// 选择动火作业负责人
	workerChange: function (id) {
		this.workPermitLDData.headerDataCache.jobExecutorEmpId = id;
	},
}

root.mounted = function () {
	if (this.operaDataCache.businessJson) {
		this.fillPermitData(this.operaDataCache);
		this.workPermitLDData.operaDataCache.playFire.map(item => item.fm = Number(item.fm));
	} else {
		this.workPermitLDData.operaDataCache.sms = [];
		this.backfillPreWorkInfo(this.operaDataCache);
		this.getPermitTypeData();
	}
}

FactoryComponents.initComponent(root);
